<section>
  <button
    aria-label="Close"
    type="button" (click)="close()">
    <mat-icon svgIcon="close" />
  </button>
  <div class="info-content">
    <img src="assets/images/dialog/credit.svg" alt="">
    <h3>Not Enough Credits</h3>
    <p class="text-info">Come back when your balance resets to continue getting personalized insights and
      recommendations from Via.</p>
    <div class="reset-time">
      <p>Your balance will reset in</p>
      <h3>{{ resetTime$() }}</h3>
    </div>
    <cpd-flat-button color="primary" text="Close" (click)="close()" />
  </div>
</section>
